const TRANSACTION_FREQUENCIES = [
  { label: "One time transaction", value: "onetimetransaction" },
  { label: "Once a week", value: "weekly" },
  { label: "Once a month", value: "onceamonth" },
  { label: "Twice a month", value: "twiceamonth" },
  { label: "Once a quarter", value: "onceaquarter" },
  { label: "Once a year", value: "onceayear" }
];

export const TRANSACTION_FREQUENCIES_LABELS = TRANSACTION_FREQUENCIES.reduce(
  (prev, next) => {
    prev[next.value] = next.label;

    return prev;
  },
  {}
);

export default TRANSACTION_FREQUENCIES;
